
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Ug8x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $67c012166b43ab0c$export$6503ec6e8aabbaf; }, function (v) { return $67c012166b43ab0c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $67c012166b43ab0c$export$f7ad0328861e2f03; }, function (v) { return $67c012166b43ab0c$export$f7ad0328861e2f03 = v; });
var $67c012166b43ab0c$export$6503ec6e8aabbaf;
var $67c012166b43ab0c$export$f7ad0328861e2f03;
"use strict";
var $67c012166b43ab0c$var$mapping = new Map();
function $67c012166b43ab0c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$67c012166b43ab0c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $67c012166b43ab0c$var$resolve(id) {
    var resolved = $67c012166b43ab0c$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$67c012166b43ab0c$export$6503ec6e8aabbaf = $67c012166b43ab0c$var$register;
$67c012166b43ab0c$export$f7ad0328861e2f03 = $67c012166b43ab0c$var$resolve;

});

parcelRegister("92HC5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $695621aa74b73e2a$export$bdfd709ae4826697; }, function (v) { return $695621aa74b73e2a$export$bdfd709ae4826697 = v; });
var $695621aa74b73e2a$export$bdfd709ae4826697;
var $695621aa74b73e2a$export$c9e73fbda7da57b6;
var $695621aa74b73e2a$export$5a759dc7a1cfb72a;
"use strict";
var $695621aa74b73e2a$var$bundleURL = {};
function $695621aa74b73e2a$var$getBundleURLCached(id) {
    var value = $695621aa74b73e2a$var$bundleURL[id];
    if (!value) {
        value = $695621aa74b73e2a$var$getBundleURL();
        $695621aa74b73e2a$var$bundleURL[id] = value;
    }
    return value;
}
function $695621aa74b73e2a$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $695621aa74b73e2a$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $695621aa74b73e2a$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $695621aa74b73e2a$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$695621aa74b73e2a$export$bdfd709ae4826697 = $695621aa74b73e2a$var$getBundleURLCached;
$695621aa74b73e2a$export$c9e73fbda7da57b6 = $695621aa74b73e2a$var$getBaseURL;
$695621aa74b73e2a$export$5a759dc7a1cfb72a = $695621aa74b73e2a$var$getOrigin;

});

parcelRegister("cgGM2", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("2z3D3"))((parcelRequire("8Ug8x")).resolve("hMkJE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8y03O"))
]).then(()=>parcelRequire('i1SEA'));

});
parcelRegister("2z3D3", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case 'prefetch':
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});


var $fabb1aaeef0a0cce$exports = {};


(parcelRequire("8Ug8x")).register((parcelRequire("92HC5")).getBundleURL('g63Tr'), JSON.parse("[\"g63Tr\",\"as-modern.js\",\"8y03O\",\"wimmel.module.ad5706d7.js\",\"hMkJE\",\"wimmel.module.be205727.css\"]"));

"use strict";
function $25865e9d3dfe9009$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $25865e9d3dfe9009$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $25865e9d3dfe9009$var$_typeof(o);
}
function $25865e9d3dfe9009$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($25865e9d3dfe9009$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $25865e9d3dfe9009$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $25865e9d3dfe9009$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $25865e9d3dfe9009$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}

if (document.querySelector(".wimmelpicture")) Promise.resolve().then(function() {
    return (parcelRequire("cgGM2"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    return module.init();
});
 // if (document.querySelector(".modal")) {
 //   import("./modules/modal.module.js").then((module) => module.init());
 // }
 // if (document.querySelector(".swiper-container")) {
 //   import("./modules/swiper.module.js").then((module) => module.init());
 // }
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // let attempts = 0;
 // const whenComplete = () => {
 //   if (++attempts > 30) return;
 //   if (document.readyState === "complete") {
 //     // --- code ---
 //   } else {
 //     setTimeout(() => whenComplete(), 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (++styleAttempts > 30) return;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(() => stylesComplete(), 300);
 //   }
 // };
 // stylesComplete();


//# sourceMappingURL=as-modern.js.map
